// Chargeback state of an order (latest Stripe dispute). Open disputes block
// dispatch to Gelato; won ones clear it.
export function DisputeBadge({ status }: { status: string }) {
  const won = status === 'won' || status === 'warning_closed';
  const lost = status === 'lost';
  const label = won ? 'DISPUTE WON' : lost ? 'DISPUTE LOST' : 'DISPUTED';
  return (
    <span
      title={`Stripe dispute: ${status.replace(/_/g, ' ')}`}
      style={{
        marginLeft: 6,
        padding: '1px 6px',
        borderRadius: 4,
        background: won ? '#dcfce7' : '#fee2e2',
        color: won ? '#166534' : '#991b1b',
        fontSize: 11,
        fontFamily: 'system-ui, sans-serif',
        fontWeight: 600,
        letterSpacing: 0.4,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  );
}
